import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditOutlined = _resolveComponent("EditOutlined")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "wrapper",
    class: "inline-edit",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["stop"]))
  }, [
    (_ctx.isEditing)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          ref: "inputRef",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
          placeholder: "文本不能为空",
          class: _normalizeClass([{ 'input-error': !_ctx.validateCheck }, "ant-input"])
        }, null, 2)), [
          [_vModelText, _ctx.innerValue]
        ])
      : _renderSlot(_ctx.$slots, "default", {
          key: 1,
          text: _ctx.innerValue
        }, () => [
          _createElementVNode("span", null, _toDisplayString(_ctx.innerValue), 1),
          _renderSlot(_ctx.$slots, "suffix", {}, () => [
            _createVNode(_component_EditOutlined, { class: "ml-2 text-sm text-white" })
          ])
        ])
  ], 512))
}